// srt-tare-gross.js

// Tare / Gross / Payload Mass section logic at top of the Axle Load accordion

import { VEHICLE_TYPE_RULES } from '../../common/srt/srt-common-presets.js';

export function initPayloadCalculation(unitIdx = 0) {
   // Bind inputs
   [`#f-gross-mass-${unitIdx}`, `#f-tare-mass-${unitIdx}`].forEach((selector) => {
      $(selector).on('input', () => updatePayload(unitIdx, 'front'));
   });

   [`#r-gross-mass-${unitIdx}`, `#r-tare-mass-${unitIdx}`].forEach((selector) => {
      $(selector).on('input', () => updatePayload(unitIdx, 'rear'));
   });
}

// Update the payload section for the specified vehicle type and unit index (when user changes vehicle) and page load
export function updatePayloadLoadOptions(vt, unitIndex) {
   applyPayloadLoadDefaults(vt, unitIndex); // Apply defaults based on vehicle type
   updateAllPayloads(unitIndex);
}

export function applyPayloadLoadDefaults(vt, unitIndex) {
   const rule = VEHICLE_TYPE_RULES[vt];
   if (!rule) {
      console.warn(`Unknown vehicle type: ${vt}`);
      return;
   }

   // Helper to set a field by group and field name
   const setField = (group, field, value) => {
      const prefix = group === 'front' ? 'f' : 'r';
      const fieldSelector = `${prefix}-${field}-${unitIndex}`;
      $(`#${fieldSelector}`).val(value);
   };

   // Apply defaults for front axle group if applicable
   if (rule.front.max > 0) {
      setField('front', 'tare-mass', rule.front.defaultTare ?? '');
      setField('front', 'gross-mass', rule.front.defaultGross ?? '');
   } else {
      // If no front axles, clear the front tare and gross mass fields
      $(`#f-tare-mass-${unitIndex}`).val('');
      $(`#f-gross-mass-${unitIndex}`).val('');
   }

   // Apply defaults for rear axle group always
   setField('rear', 'tare-mass', rule.rear.defaultTare ?? '');
   setField('rear', 'gross-mass', rule.rear.defaultGross ?? '');
}

function updatePayload(unitIdx, side) {
   // just update all payloads
   const fr = side === 'front' ? 'f' : 'r';
   const $gross = $(`#${fr}-gross-mass-${unitIdx}`);
   const $tare = $(`#${fr}-tare-mass-${unitIdx}`);
   const $payload = $(`#${fr}-payload-mass-${unitIdx}`);
   const gross = parseFloat($gross.val());
   const tare = parseFloat($tare.val());
   const payload = gross - tare;
   if (payload < 0) {
      $payload.val(payload.toFixed(0)).addClass('is-invalid');
   } else {
      $payload.val(payload.toFixed(0)).removeClass('is-invalid');
   }
}

export function updateAllPayloads(unitIdx) {
   updatePayload(unitIdx, 'front');
   updatePayload(unitIdx, 'rear');
}
